import { api } from '@alltrails/core/utils/api';
import { destroy } from '@alltrails/core/utils/destroy';
import { get } from '@alltrails/core/utils/get';
import { put } from '@alltrails/core/utils/put';
import type { BelayUserConnection, ConnectionPageResponse, UserConnectionStatus } from '@alltrails/types/belay';
import type { FacebookStatus } from '@alltrails/types/FacebookStatus';
import type { UserId } from '@alltrails/types/User';

const getConnectionsUrl = (status: UserConnectionStatus, userId: number): string => {
  switch (status) {
    case 'suggested-follow':
      return '/api/alltrails/connect/v0/my/suggestions';
    case 'mutual':
      return `/api/alltrails/connect/v0/my/mutuals/${userId}`;
    case 'blocking':
      return '/api/alltrails/connect/v0/my/blocks';
    default:
      return `/api/alltrails/connect/users/${userId}/connections?filter[statuses]=${status}`;
  }
};

export const getConnections = (status: UserConnectionStatus, userId: number) => {
  const url = getConnectionsUrl(status, userId);
  return get<ConnectionPageResponse>(url);
};

export const getConnectionsNextPage = (url: string) => get<ConnectionPageResponse>(url);

export const getReviewsConnections = (userIds: UserId[], userId?: number) =>
  get<ConnectionPageResponse>(`/api/alltrails/connect/users/${userId}/connections?filter[userIds]=${userIds}&limit=${userIds?.length}`);

export const getUserConnectionStatus = (userId: number, otherUserId: number) =>
  get<BelayUserConnection>(`/api/alltrails/connect/users/${userId}/connections/${otherUserId}`);

export const userActionRequest = (href: string, method: RequestInit['method']) => api<BelayUserConnection>(href, { method });

export const getFacebookUploadStatus = (userId: number) =>
  get<{
    contactUploads: {
      facebook: {
        status: FacebookStatus;
      };
    };
  }>(`/api/alltrails/connect/users/${userId}?include=contact-uploads.facebook`);

export const uploadFacebookTokenToBelay = (token: string, userId: number) => {
  const data = { token, source: 'facebook', tokenType: 'access' };
  return put<{ status: FacebookStatus }>(`/api/alltrails/connect/users/${userId}/contact-uploads/facebook`, data);
};

export const stopSyncFacebookFriends = (userId: number) => destroy(`/api/alltrails/connect/users/${userId}/identities/facebook`);
